import { Skeleton } from "../../components/Skeleton";
import { WorkoutFolders } from "../../components/WorkoutTemplatesTable/WorkoutFolders";
import {
  useGetAllWorkoutQuery,
  useGetAllWorkoutContainersQuery,
} from "../../libs/workout/api";

export default function Workout() {
  const { data, isLoading, error } = useGetAllWorkoutQuery();
  const { data: containers, isLoading: containersLoading } =
    useGetAllWorkoutContainersQuery();
  if (isLoading || containersLoading) {
    return <Skeleton />;
  }
  if (error || !data) {
    return <div>Error...</div>;
  }
  return (
    <div>
      <WorkoutFolders templates={data.templates} containers={containers ?? []} />
    </div>
  );
}
